// @ts-nocheck

import { useEffect, useState } from "react";
import { PMGrid, TableWidget } from "lib";

import { useParams } from "react-router-dom";
import { setStore } from "store/appSlice";
import { useDispatch } from "react-redux";

import { useBranchRenewalsDoneListQuery } from "store/apiSlice";
function BranchRenewalsList() {
    // Hold page variables to avoid polluting variable space
    var page = {
        data: {},
        parameters: {
            route: {},
        },
    };

    ({ sales_branch: page.parameters.route.sales_branch } = useParams());
    const dispatch = useDispatch();
    dispatch(setStore({ currentPageTitle: "" }));
    [page.parameters.branchListFilters, page.parameters.branchListFiltersSet] = useState({});
    [page.parameters.branchListPagination, page.parameters.branchListPaginationSet] = useState({ size: 50 });
    const branchRenewalsDoneListParams = { sales_branch: page.parameters.route.sales_branch };
    ({
        data: page.data.branchRenewalsDoneListData,
        isFetching: page.data.branchRenewalsDoneListDataIsFetching,
        isLoading: page.data.branchRenewalsDoneListDataIsLoading,
    } = useBranchRenewalsDoneListQuery(branchRenewalsDoneListParams));

    return (
        <div className="builder_wrapper">
            <PMGrid container={true} marginTop={2}>
                <TableWidget
                    showSerialNumber={false}
                    showQuickFilter={false}
                    header="RM wise Renewals Data"
                    hideFooter={true}
                    xs={12}
                    tableApi={page.data.branchRenewalsDoneListData || []}
                    tableParams={[page.parameters.renewalListPagination, page.parameters.renewalListPaginationSet]}
                    columns={[
                        { field: "rm_name", headerName: "RM Name" },
                        { field: "rm_code", headerName: "RM Code", type: "relatedlink" },
                        { field: "total_renewals", headerName: "Total Renewals" },
                        { field: "total_premium", headerName: "Total Premium", type: "currency" },
                        { field: "pending", headerName: "Pending" },
                        { field: "done", headerName: "Done" },
                        { field: "missed", headerName: "Missed" },
                    ]}
                ></TableWidget>
            </PMGrid>
        </div>
    );
}
export default BranchRenewalsList;
